import { SAVE_COURSE_DATA } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_COURSE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
